export const colors = {
    defaultBg: "#CF3933"
}